/* eslint-disable @typescript-eslint/no-explicit-any */
import { FormikProps } from 'formik';
import { Button, Text, makeStyles, mergeClasses, tokens } from '@fluentui/react-components';
import { AddCircle12Regular, CalendarMultipleRegular } from '@fluentui/react-icons';
import { Column, CustomCardHeader, BrandCard } from '../../../common';
import { CaseEventControl } from '../../../controls/CaseEventControl';
import { AddEditCaseEventDialog } from '../../../dialogs/AddEditCaseEventDialog';
import { Case, CaseEvent } from '../../../../data/types';

export const useStyles = makeStyles({
    root: {},
    noEvents: {
        color: tokens.colorNeutralForeground3,
    },
    eventColumn: {
        maxHeight: '15rem',
        overflowY: 'auto',
    },
    eventControl: {
        minWidth: '100%',
    },
    addContactBtn: {
        fontSize: '13px',
        paddingBlockStart: '0',
        paddingBlockEnd: '0',
        ':focus': {
            outline: 'none',
            boxShadow: 'none',
        },
    },
});
export type CaseEventsCardProps = {
    className?: string;
    caseForm?: FormikProps<Case>;
    eventPanelClassName?: string;
};
export const CaseEventsCard = (props: CaseEventsCardProps) => {
    const { className, caseForm, eventPanelClassName } = props;

    //Styles
    const styles = useStyles();
    const cardClasses = mergeClasses(styles.root, className);

    //UI Events
    const clickAddEvent = async (event: CaseEvent | any) => {
        event.caseId = caseForm?.values.caseId;
        caseForm?.setFieldValue('caseEvents', [...(caseForm.values.caseEvents || []), event]);
    };
    const onEditEvent = async (event: CaseEvent) => {
        const caseEvents = caseForm?.values.caseEvents;
        const eventIndex = caseEvents?.findIndex((obj: CaseEvent) => obj.eventId === event.eventId);
        if (!!eventIndex && eventIndex >= 0) {
            caseForm?.setFieldValue('caseEvents', [
                ...(caseEvents?.slice(0, eventIndex) || []),
                event,
                ...(caseEvents?.slice(eventIndex + 1) || []),
            ]);
        } else {
            caseForm?.setFieldValue('caseEvents', [...(caseEvents || []), event as CaseEvent]);
        }
    };
    const onDeleteEvent = (event: CaseEvent) => {
        const caseEvents = caseForm?.values.caseEvents;
        caseForm?.setFieldValue('caseEvents', caseEvents?.filter((obj: CaseEvent) => obj.eventId !== event.eventId) || []);
    };

    return (
        <>
            <BrandCard className={cardClasses}>
                <CustomCardHeader
                    title='Events'
                    icon={<CalendarMultipleRegular />}
                    action={
                        <AddEditCaseEventDialog onSubmit={clickAddEvent} caseId={caseForm?.values.caseId as string}>
                            <Button
                                className={styles.addContactBtn}
                                icon={<AddCircle12Regular />}
                                appearance='transparent'
                                data-testid='case-events-add-event-btn'
                            >
                                Add Event
                            </Button>
                        </AddEditCaseEventDialog>
                    }
                />
                {!caseForm?.values.caseEvents?.length ? (
                    <Column align='center'>
                        <Text className={styles.noEvents} size={400}>
                            No Events Scheduled yet
                        </Text>
                    </Column>
                ) : (
                    <Column className={eventPanelClassName} padding='px-3'>
                        <div className={styles.eventColumn}>
                            {[...(caseForm?.values.caseEvents || [])]
                                .sort((a: CaseEvent, b: CaseEvent) => (a.date?.valueOf() || 0) - (b.date?.valueOf() || 0))
                                .map((event: CaseEvent) => (
                                    <CaseEventControl
                                        key={event.eventId}
                                        className={styles.eventControl}
                                        event={event}
                                        onEdit={onEditEvent}
                                        onDelete={() => onDeleteEvent(event)}
                                    />
                                ))}
                        </div>
                    </Column>
                )}
            </BrandCard>
        </>
    );
};
